<ng-container *ngIf="kinderZumAnmelden; else noKinder">
    <ng-container *ngIf="!anmeldungenAktiv;  else aktiv">
        <ng-container *ngIf="showTimer; else noTimer">
            <div class="rounded grayFontColor primaryBgColor d-flex flex-row p-2">
                <div class="align-self-center mx-2 flex-grow-0"><i class="fa fa-3x fa-info-circle"></i></div>
                <div class="align-middle align-self-center flex-grow-1">
                    Der Anmeldezeitraum beginnt in kürze, und Sie können die Kinder dann
                    anmelden.
                    Zum Anmelden der Kinder bitte dann diesen Button drücken.
                </div>
                <button class="btn scButton align-self-center flex-grow-0 text-nowrap" disabled>Kinder Anmelden<br>({{timerTxt}})</button>
                <div class="align-self-center mx-2 flex-grow-0"><i class="fa fa-3x fa-info-circle"></i></div>
            </div>
        </ng-container>
        <ng-template #noTimer>
            <div class="pcBorder rounded text-center p-2">
                <i class="fas fa-info-circle"></i>
                Anmeldungen sind noch nicht aktiv. Es können Voranmeldungen gemacht werden, welche ab
                dem {{ anmeldungenDatum | datum }} {{ anmeldungenDatum | zeit }} dann mit einem Klick in Anmeldungen
                geändert werden können.
            </div>
        </ng-template>
    </ng-container>
    <ng-template #aktiv>
        <ng-container *ngIf="anmeldungErledigt; else anmeldenBtn">
            <div class="grayFontColor primaryBgColor rounded p-2 text-center">
                <i class="fas fa-info-circle"></i>
                Sie haben die Kinder erfolgreich an den Aktionen angemeldet. Der Anmeldungsstatus wird in kürze aktualisiert.
            </div>
        </ng-container>
        <ng-template #anmeldenBtn>
            <div class="rounded grayFontColor primaryBgColor d-flex flex-row p-2">
                <div class="align-self-center mx-2"><i class="fa fa-3x fa-info-circle"></i></div>
                <div class="align-middle align-self-center">
                    Sie haben Kinder Vorangemeldet. Der Anmeldezeitraum hat begonnen, und sie können die Kinder jetzt
                    anmelden.
                    Zum Anmelden der Kinder bitte den Button drücken.
                </div>
                <button class="btn scButton align-self-center" [disabled]="loading" (click)="kinderAnmelden()">Kinder Anmelden</button>
                <div class="align-self-center mx-2"><i class="fa fa-3x fa-info-circle"></i></div>
            </div>
        </ng-template>
    </ng-template>
</ng-container>

<ng-template #noKinder>
    <ng-container *ngIf="!anmeldungenAktiv && loggedIn">
        <div class="pcBorder rounded text-center p-2">
            <i class="fas fa-info-circle"></i>
            Es wurden noch keine Kinder an Aktionen vorangemeldet. Die Voranmeldung sollte bis zum {{ anmeldungenDatum | datum }} {{ anmeldungenDatum | zeit }}
            erfolgen.
        </div>
    </ng-container>
</ng-template>
